namespace GeniuzPOS.Purchase {
    export enum usefg {
        nonuse = 0,
        close = 1,
        usesome = 2
    }
    Serenity.Decorators.registerEnumType(usefg, 'GeniuzPOS.Purchase.usefg');
}
